import React from 'react';
import { useRecoilState } from 'recoil';
import searchRequestAtom from '../../recoils/useSearchRequest/searchRequestAtom';
import { IFilterParam } from '../../models/IFilterParam';
import { ISearchQueryRequest } from '../../models/ISearchQueryRequest';
import { IdObject } from '../../models/IdObject';
import { removeDuplicates, uniqueFilterRequest, getAndUpdateRequestForFilter } from '../../ultils';
import './BoxCellCustom.scss';
import selectedCheckboxsAtom from '../../recoils/useSelectedCheckboxsReverseSearch/selectedCheckboxsAtom';
interface IProps {
  props: any;
}

export const BoxCellCustom: React.FC<IProps> = ({ props }) => {
  const [listCheckbox, setListCheckBox] = useRecoilState(selectedCheckboxsAtom);
  const [searchQuery, setSearchQuery] = useRecoilState(searchRequestAtom);
  const { data } = props;
  if (props) {
    //set style ag-cell-wrapper
    props.eParentOfValue?.__agComponent?.eCellValue?.setAttribute(
      'style',
      'width:100%;'
    );
  }

  const handleCheckBoxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let parametricFilters: IFilterParam[] = searchQuery.parametricFilters
      ? [...searchQuery.parametricFilters]
      : [];
    let updateRequest: ISearchQueryRequest = {
      ...searchQuery
    };
    //update search request
    //these below use another method to update request
    switch (props.colDef.field) {
      //Unique request
      case 'partStatus':
        updateRequest = getAndUpdateRequestForFilter(searchQuery, searchQuery.productStatusFilter, data.partStatusId, e.target.checked)
        break;
      //Unique request
      case 'packageTypeCellRenderer':
        let packageFilter: IdObject[] = searchQuery.packagingFilter
          ? [...searchQuery.packagingFilter]
          : [];
        data?.productVariations.forEach((iProduct: any) => {
          let newFilter: IdObject = {
            id: iProduct.packageType.id.toString()
          };
          packageFilter = [...packageFilter, newFilter];
        });
        packageFilter = removeDuplicates(packageFilter,'id')
        updateRequest = uniqueFilterRequest(
          updateRequest,
          packageFilter,
          'packagingFilter',
          e.target.checked
        );
        break;
      //Unique request
      case 'seriesName':
        let seriesFilter: IdObject[] = searchQuery.seriesFilter
          ? [...searchQuery.seriesFilter]
          : [];
        let newFilter: IdObject = { id: data.seriesId.toString() };
        seriesFilter = [...seriesFilter, newFilter];
        updateRequest = uniqueFilterRequest(
          updateRequest,
          seriesFilter,
          'seriesFilter',
          e.target.checked
        );
        break;
      default:
        const getParam = data.parameters.find((iParam: any) => {
          return iParam.parameterId === props.colDef.parameterId;
        });
        if (e.target.checked) {
          const newParamFilter: IFilterParam = {
            filterValues: [
              {
                valueId: getParam.valueId
              }
            ],
            parameterId: getParam.parameterId,
            parameterType: getParam.parameterType
          };
          updateRequest = {
            ...searchQuery,
            parametricFilters: [...parametricFilters, newParamFilter]
          };
        } else {
          parametricFilters = parametricFilters.filter(
            (eParam: IFilterParam) => {
              return eParam.parameterId !== getParam.parameterId;
            }
          );
          if (parametricFilters.length > 0) {
            updateRequest = {
              ...searchQuery,
              parametricFilters: [...parametricFilters]
            };
          } else {
            updateRequest = {
              ...searchQuery,
              parametricFilters: undefined
            };
            delete updateRequest.parametricFilters;
          }
        }
    }

    if (e.target.checked) {
      let newList = [...listCheckbox, props.colDef.field];
      setListCheckBox([...newList]);
    } else {
      let newList = listCheckbox.filter((iCheckbox: string) => {
        return iCheckbox !== props.colDef.field;
      });
      setListCheckBox([...newList]);
    }

    setSearchQuery(updateRequest);
  };

  return (
    <div
      style={{ height: 80, placeItems: 'center', display: 'grid' }}
      className="filter-container"
    >
      <div className="dk-checkbox-group " id="include-matching-cb-gr">
        <input
          type="checkbox"
          className="dk-checkbox dk-checkbox-matching-part"
          id="include-matching-cb"
          col-id={props.colDef.field}
          data-testid="include-matching-cb"
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            handleCheckBoxChange(e)
          }
        />
      </div>
    </div>
  );
};
